import script from "./CalendarAttachments.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarAttachments.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarAttachments.vue?vue&type=style&index=0&id=5752a99b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5752a99b"]])

export default __exports__